import { Section } from 'services/api/vehicle-sections/types';

export type FormPathFinder = (
  sections: Record<string, Section>,
  id: number | string,
  initialPath?: string
) => string | null;

export const findSectionPath: FormPathFinder = (sections, targetId, currentPath = ''): string | null => {
  for (const key in sections) {
    const section = sections[key];
    const pathSegment = currentPath ? `${currentPath}.subsections.${key}` : key;

    if (section.id === targetId) {
      return pathSegment;
    }

    if (section.subsections && Object.keys(section.subsections).length > 0) {
      const nestedPath = findSectionPath(section.subsections, targetId, pathSegment);
      if (nestedPath) return nestedPath;
    }
  }

  return null;
};

export const findImagePath: FormPathFinder = (sections, imageId, currentPath = ''): string | null => {
  for (const key in sections) {
    const section = sections[key];
    const basePath = currentPath ? `${currentPath}.subsections.${key}` : key;

    const imageIndex = (section.images || []).findIndex(img => img.id === imageId);
    if (imageIndex !== -1) {
      return `${basePath}.images[${imageIndex}]`;
    }

    if (section.subsections && Object.keys(section.subsections).length > 0) {
      const nestedPath = findImagePath(section.subsections, imageId, basePath);
      if (nestedPath) return nestedPath;
    }
  }

  return null;
};

export const findCheckboxPath: FormPathFinder = (sections, checkboxId, currentPath = ''): string | null => {
  for (const key in sections) {
    const section = sections[key];
    const basePath = currentPath ? `${currentPath}.subsections.${key}` : key;

    const checkboxIndex = (section.checkboxes || []).findIndex(cb => cb.id === checkboxId);
    if (checkboxIndex !== -1) {
      return `${basePath}.checkboxes[${checkboxIndex}]`;
    }

    if (section.subsections && Object.keys(section.subsections).length > 0) {
      const nestedPath = findCheckboxPath(section.subsections, checkboxId, basePath);
      if (nestedPath) return nestedPath;
    }
  }

  return null;
};

export const entityToPathFinderMap = {
  checkbox: findCheckboxPath,
  image: findImagePath,
  section: findSectionPath
};

const notesOpenSections = ['under_hood', 'interior_overall', 'exterior_paint'];

export const isNotesAlwaysOpened = (sectionId: string) => {
  return notesOpenSections.includes(sectionId)
};
